<template>
  <div class="details" v-bind:class="[isScreenOpen, isDetailsOpen]">
    <div class="caption">
      <router-link
        :to="{ path: '/projects' }"
        class="close-button"
      ></router-link>
      <div class="dippy">{{ currentImages[currentSlideIndex].desc }}</div>
      <a
        href="#"
        @click="showHideDetails"
        class="details-button icon info brick-button"
      ></a>
    </div>

    <swiper class="details-preview" :options="swiperOption" ref="mySwiper">
      <!-- Videos -->
      <swiper-slide
        v-for="(image, index) in currentImages"
        v-bind:key="image.image"
      >
        <iframe
          class="video"
          v-if="image.youtube"
          width="100%"
          height="100%"
          :src="image.youtube + '?controls=0&modestbranding=1&rel=0&showinfo=0'"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
        <div
          v-if="image.image"
          class="swiper-slide-inner"
          :key="index"
          :style="{
            backgroundImage:
              'url(' + require('@/assets/img/' + image.image) + ')',
            backgroundPosition:
              image.size === 'contain' ? 'center center' : backgroundPosition,
            backgroundSize: image.size || 'cover',
          }"
        ></div>
        <video
          v-if="image.video"
          playsinline
          webkit-playsinline
          ref="videoPlayers"
          class="vid"
          muted
          autoplay
          loop
        >
          <source
            :src="require('@/assets/video/' + image.video + '.webm')"
            type="video/webm"
          />
          <source
            :src="require('@/assets/video/' + image.video + '.mp4')"
            type="video/mp4"
          />
        </video>
      </swiper-slide>
      <!-- Optional controls -->
      <div class="swiper-pagination" slot="pagination">
        <div
          v-if="currentImages[currentSlideIndex].image"
          class="scrolly"
          @mousemove="(e) => updateBackgroundPosition(e)"
          @touchmove="(e) => updateBackgroundPosition(e, true)"
        >
          <div
            class="circle"
            :style="{ top: circleY + 'px', left: circleX + 'px' }"
          ></div>
        </div>
      </div>
      <div class="swiper-controls"></div>
      <div
        class="swiper-button-prev swiper-button-white"
        slot="button-prev"
      ></div>
      <div
        class="swiper-button-next swiper-button-white"
        slot="button-next"
      ></div>
    </swiper>
  </div>
  <!--/.offscreen-->
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "Details",
  data() {
    return {
      circleX: 0,
      circleY: 0,
      backgroundPosition: "center center",
      currentSlideIndex: 0,
      swiperOption: {
        touchEventsTarget: "wrapper",
        shortSwipes: true,
        simulateTouch: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  props: {
    item: Object,
  },
  components: {
    swiper,
    swiperSlide,
  },
  computed: {
    activeFolioId: function () {
      return this.$store.state.activeFolioId;
    },
    currentFolio: function () {
      return this.$store.getters.getFolioById(this.activeFolioId);
    },
    currentImages: function () {
      return this.currentFolio.images || [];
    },
    currentVideos: function () {
      return this.currentFolio.videos || [];
    },
    isScreenOpen: function () {
      if (this.$store.state.folioOpen !== false) {
        return "open";
      }
      return "";
    },
    isDetailsOpen: function () {
      if (this.$store.state.detailsOpen !== false) {
        return "details-open";
      }
      return "";
    },
  },
  watch: {
    $route(route) {
      if (route.name === "folio-item") {
        this.$refs.mySwiper.swiper.slideTo(0, 0, false);
        if (this.$refs.videoPlayers)
          for (const vid of this.$refs.videoPlayers) {
            vid.play();
          }
      } else {
        if (this.$refs.videoPlayers)
          for (const vid of this.$refs.videoPlayers) {
            vid.pause();
          }
      }
    },
  },
  mounted() {
    this.currentSlideIndex = this.$refs.mySwiper.swiper.activeIndex;
    this.$refs.mySwiper.swiper.on("slideChange", this.onSlideChange);
  },
  beforeDestroy() {
    this.$refs.mySwiper.swiper.off("slideChange", this.onSlideChange);
  },
  methods: {
    updateBackgroundPosition(event, isTouch = false) {
      const buffer = 0.0; // 10% buffer zone
      const element = event.target;
      const rect = element.getBoundingClientRect();

      let x, y;

      if (isTouch) {
        x = event.touches[0].clientX - rect.left; // x position within the element
        y = event.touches[0].clientY - rect.top; // y position within the element
      } else {
        x = event.clientX - rect.left; // x position within the element
        y = event.clientY - rect.top; // y position within the element
      }

      const xPercent = (x / rect.width) * 100;
      const yPercent = (y / rect.height) * 100;

      this.circleX = x; // Adjust for circle radius (25px for a 50px circle)
      this.circleY = y; // Adjust for circle radius (25px for a 50px circle)

      // Map 0-100% within the element to 0-100% for the background image
      let adjustedXPercent = (xPercent - 50) * (100 / (50 - 50 * buffer)) + 50;
      let adjustedYPercent = (yPercent - 50) * (100 / (50 - 50 * buffer)) + 50;

      adjustedXPercent = Math.min(Math.max(adjustedXPercent, 0), 100);
      adjustedYPercent = Math.min(Math.max(adjustedYPercent, 0), 100);

      this.backgroundPosition = `${adjustedXPercent}% ${adjustedYPercent}%`;
    },
    onSlideChange() {
      this.currentSlideIndex = this.$refs.mySwiper.swiper.activeIndex;
    },
    showHideDetails: function (e) {
      e.preventDefault();
      if (this.$store.getters.detailsOpen) {
        this.$store.dispatch("updateDetailsOpen", false);
      } else {
        this.$store.dispatch("updateDetailsOpen", true);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.video {
  margin-top: -90px;
  height: calc(100dvh + 90px);
}
.coverer {
  position: fixed;
  width: 100%;
  height: 100%;
}
.details {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: -100%;
  bottom: 0;
  z-index: 2;
  list-style: none;
  background: #111 url("../assets/img/spinner.gif") center center no-repeat;
  transition: 1s ease all;
  opacity: 0;
  .swiper-slide-inner,
  .swiper-slide {
    position: relative;
    height: 100dvh;
    width: 100%;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
  }
  .swiper-slide {
    transition: 1s ease height, 1s ease margin-top;
    overflow: hidden;
  }
  &.open {
    right: 0%;
    opacity: 1;
  }
}
.circle {
  position: absolute;
  width: 150px;
  height: 150px;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 50%
  );
  pointer-events: none; /* Makes sure the circle doesn't interfere with mouse events */
  opacity: 0.15;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}
.dippy {
  opacity: 0;
  transition: 1s ease all;
  flex: 1;
}
.details-button {
  flex-shrink: 0;
  background-color: #333;
}
.caption {
  transition: 0.5s ease all;
  display: flex;
  gap: 10px;
  background: transparent;
  position: absolute;
  align-items: center;
  top: 0px;
  right: 0px;
  left: 0px;
  padding: 10px;
  color: #fff;
  z-index: 99;
}
.close-button {
  flex-shrink: 0;
  transition: 1s ease all;
}
.details-open {
  .caption {
    background: #333;
  }
  .dippy {
    opacity: 1;
  }
  .details-button {
    flex-shrink: 0;
    background-color: #444;
  }
  .close-button {
    background-color: #444;
  }
  .swiper-slide {
    margin-top: 90px;
    height: calc(100dvh - 90px);
  }
}
.swiper-pagination {
  transition: 0.5s ease all;
  bottom: 10px;
  right: 10px;
  height: 70px;
  width: 100px;
  background-color: #333;
  z-index: 2;
  border-radius: 50px;
  display: flex;
  padding: 0 62px;
  overflow: hidden;
}
.scrolly {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}
.swiper-button-white {
  z-index: 4;
  background: #444;
  border-top: 1px solid #888;
  display: block;
  width: 50px;
  height: 50px;
  border-radius: 100%;
  background-position: 50%;
  background-size: 50%;
  outline: none;
}
.swiper-button-next {
  right: 20px;
  &:before {
    content: "";
    width: 100%;
    height: 100%;
    display: block;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: 30%;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E");
  }
}
.swiper-button-prev {
  left: auto;
  right: 174px;
  &:before {
    content: "";
    width: 100%;
    height: 100%;
    display: block;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: 30%;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E");
  }
}
.swiper-button-next,
.swiper-button-prev {
  bottom: 20px;
  top: auto;
}
video {
  position: absolute;
  width: 100vw;
  top: 50%;
  left: 0;
  transform: translate(0%, -50%);
}
@media (min-width: 800px) {
  .details {
    .swiper-slide-inner {
      background-size: contain !important;
      background-position: center center !important;
    }
  }
  .scrolly {
    .circle {
      display: none;
    }
  }
}
@media (max-width: 800px) {
  video {
    width: 150vw;
  }
  .scrolly {
    &:before {
      font-size: 11px;
      text-transform: uppercase;
      content: "Drag me";
      color: #fff;
      opacity: 0.25;
    }
  }
}
</style>
